import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import axios from 'axios';

export function initSentry(vue, router) {
  Sentry.init({
    vue,
    dsn: 'https://f7d01a52e1b04292834f1daa40ae2ad9@sentry.io/300342',
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: [
          'api.signableapi.com',
          'staging.api.signableapi.com',
          'qa.api.signableapi.com',
          'api.signable.test',
          /^\//,
        ],
      }),
    ],
    tracesSampleRate: 1.0,
    trackComponents: true,
    environment: process.env.VUE_APP_ENV,
    release: process.env.VUE_APP_COMMIT,
    ignoreErrors: [
      // Random plugins/extensions
      'top.GLOBALS',
      // Commonly reported errors
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications.',
      'NavigationDuplicated',
      'LaunchDarklyFlagFetchError',
      'Validating a non-existent field',
      // Unauthorised
      'Request failed with status code 401',
      // finally
      'Object doesn\'t support property or method \'finally\'',
    ],
    allowUrls: [
      /https?:\/\/((www|staging|qa)\.)?signable\.app/,
      /https?:\/\/([a-zA-z0-9-]+)\.s3-website\.eu-west-2\.amazonaws\.com/, // for review apps
    ],
    beforeSend(event, hint) {
      /**
       * Cancelled requests shouldn't be logged to sentry
       */
      if (axios.isCancel(hint.originalException)) {
        return null;
      }
      if (process.env.VUE_APP_ENV !== 'production') {
        // Log error to console in non production environments
        // eslint-disable-next-line
        console.error(hint.originalException || hint.syntheticException);
        return null;
      }
      return event;
    },
    beforeBreadcrumb(breadcrumb, hint) {
      if (breadcrumb.category === 'ui.click') {
        const { target } = hint.event;

        const closestTaggedElement = target.closest('[data-et]');
        const targetTag = closestTaggedElement.dataset.et;
        const categoryTag = closestTaggedElement.dataset.ec;

        if (targetTag && categoryTag) {
          breadcrumb.message = `${categoryTag}--${targetTag}`; // eslint-disable-line no-param-reassign
        }
      }
      return breadcrumb;
    },
  });
}

export function configureSentryScope(cb) {
    Sentry.configureScope(cb);
}

export function captureSentryMessage(message, scopeCb) {
  if (scopeCb !== undefined) {
    configureSentryScope(scopeCb);
  }

  Sentry.captureMessage(message);
}
